import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ApiMessagesResponse, AppRoutesEnum } from '@shared/types';
import { ModalComponent } from '@ui-kit/miscs';

@Component({
    selector: 'api-response-modal[onHide]',
    standalone: true,
    imports: [ModalComponent, TranslateModule],
    templateUrl: './api-response-modal.component.html',
    styleUrl: './api-response-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiResponseModalComponent {
    id = input.required<string>();
    isVisible = input.required<boolean>();
    data = input.required<ApiMessagesResponse | null>();
    strainId = input<number | null>(null);

    onHide = output<void>();

    readonly appRoutes = AppRoutesEnum;
}
